import React from 'react';
import moment from 'moment';
import { Badge } from 'reactstrap';

// tableColumns.js
export const ManageBankDepositColumns = (handleEdit, handleDelete) => [
  { 
    dataField: 'id', 
    text: '#',
    style: { width: '45px', textAlign: 'center', verticalAlign: 'middle' },
    formatter: (cell, row, rowIndex) => (
      <span className="badge bg-light text-muted border font-size-11 font-weight-bold">
        {rowIndex + 1}
      </span>
    )
  },
  { 
    dataField: 'deposit_date', 
    text: 'Deposit Date',
    style: { verticalAlign: 'middle', width: '130px' },
    formatter: (cell) => (
      <div>
        <span className="font-weight-semibold text-dark font-size-13 d-block">
          {cell ? moment(cell).format('DD MMM YYYY') : '—'}
        </span>
        <small className="text-muted font-size-11">
          {cell ? moment(cell).format('hh:mm A') : ''}
        </small>
      </div>
    )
  },
  {
    dataField: 'bank_name',
    text: 'Bank & Branch Details',
    style: { verticalAlign: 'middle' },
    formatter: (cell, row) => {
      const bank = row.bank || {};
      const bankName = bank.bank_name || cell || 'Bank Account';
      const branch = bank.branch || row.branch;
      const acNo = bank.ac_no || row.ac_no;

      return (
        <div className="d-flex align-items-center gap-2.5 py-1">
          <div
            className="rounded-circle bg-info-subtle text-info d-flex align-items-center justify-content-center font-size-14 flex-shrink-0"
            style={{ width: '34px', height: '34px' }}
          >
            <i className="fas fa-university" />
          </div>
          <div>
            <div className="font-weight-bold text-dark font-size-13">
              {bankName}
            </div>
            <div className="d-flex align-items-center gap-1.5 mt-0.5 flex-wrap">
              {acNo && (
                <span className="badge bg-light text-dark border font-monospace font-size-10 px-1.5 py-0.5">
                  A/C: •••• {String(acNo).slice(-4)}
                </span>
              )}
              {branch && (
                <span className="text-muted font-size-11">📍 {branch}</span>
              )}
            </div>
          </div>
        </div>
      );
    }
  },
  { 
    dataField: 'reference_no', 
    text: 'Ref / UTR Number',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => (
      <span className="badge bg-light text-primary border font-monospace font-weight-bold font-size-11 px-2 py-1">
        {cell || 'DIRECT-DEP'}
      </span>
    )
  },
  { 
    dataField: 'deposit_amount', 
    text: 'Deposit Amount',
    style: { verticalAlign: 'middle', textAlign: 'right' },
    headerStyle: { textAlign: 'right' },
    formatter: (cell) => (
      <span className="font-weight-bold text-success font-size-14">
        ₹{parseFloat(cell || 0).toLocaleString('en-IN')}
      </span>
    )
  },
  { 
    dataField: 'note', 
    text: 'Remarks / Notes',
    style: { verticalAlign: 'middle' },
    formatter: (cell) => (
      <span className="text-muted font-size-12 text-truncate d-inline-block" style={{ maxWidth: '180px' }} title={cell || ''}>
        {cell || 'Bank Settlement'}
      </span>
    )
  },
  {
    dataField: 'actions',
    text: 'Actions',
    isDummyField: true,
    style: { verticalAlign: 'middle', textAlign: 'center', width: '90px' },
    headerStyle: { textAlign: 'center', width: '90px' },
    formatter: (cell, row) => (
      <div className="d-flex align-items-center justify-content-center gap-1.5">
        <button
          type="button"
          className="btn btn-sm btn-soft-primary rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs"
          style={{ width: '28px', height: '28px' }}
          onClick={() => handleEdit(row)}
          title="Edit Bank Deposit"
        >
          <i className="fas fa-pencil-alt font-size-11" />
        </button>
        {handleDelete && (
          <button
            type="button"
            className="btn btn-sm btn-soft-danger rounded-circle p-0 d-flex align-items-center justify-content-center shadow-2xs"
            style={{ width: '28px', height: '28px' }}
            onClick={() => handleDelete(row.id, row.status == 1 ? 0 : 1, row.code)}
            title={row.status == 0 ? 'Restore' : 'Delete'}
          >
            <i className="fas fa-trash-alt font-size-11" />
          </button>
        )}
      </div>
    )
  }
];
